import { ProviderBuilder, EGenMode } from '@educraft/base';
import * as MathAdvanced from './generators/mathAdvanced';
import * as MathFractions from './generators/mathFractions';
import * as MathClocks from './generators/mathClocks';
import * as MathNumbersEnglish from './generators/mathNumbersEnglish';

export function registerGenSingle(builder: ProviderBuilder): void {
  // Advanced / Combinatorics
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Combinatorics__Combination,
    'Eq.Math_Combinatorics__Combination'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Combinatorics__Permutation,
    'Eq.Math_Combinatorics__Permutation'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Combinatorics__Variation,
    'Eq.Math_Combinatorics__Variation'
  );

  builder.add(EGenMode.GenSingle, MathAdvanced.Math_Derivation__X2, 'Eq.Math_Derivation__X2');
  builder.add(EGenMode.GenSingle, MathAdvanced.Math_Derivation__X3, 'Eq.Math_Derivation__X3');
  builder.add(EGenMode.GenSingle, MathAdvanced.Math_Derivation__X4, 'Eq.Math_Derivation__X4');
  builder.add(EGenMode.GenSingle, MathAdvanced.Math_Derivation__X5, 'Eq.Math_Derivation__X5');

  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Equation_Quadratic__1,
    'Eq.Math_Equation_Quadratic__1'
  );

  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_PythagoreanTheorem__FindHypotenuse,
    'Eq.Math_PythagoreanTheorem__FindHypotenuse'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_PythagoreanTheorem__FindLeg,
    'Eq.Math_PythagoreanTheorem__FindLeg'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_SurfaceArea__Cube__Base,
    'Eq.Math_SurfaceArea__Cube__Base'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_SurfaceArea__Cube__Inverse,
    'Eq.Math_SurfaceArea__Cube__Inverse'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Volume__Cube__Base,
    'Eq.Math_Volume__Cube__Base'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Volume__Cube__Inverse,
    'Eq.Math_Volume__Cube__Inverse'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Volume__Sphere__Base,
    'Eq.Math_Volume__Sphere__Base'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Volume__Sphere__Inverse,
    'Eq.Math_Volume__Sphere__Inverse'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_SurfaceArea__Sphere__Base,
    'Eq.Math_SurfaceArea__Sphere__Base'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_SurfaceArea__Sphere__Inverse,
    'Eq.Math_SurfaceArea__Sphere__Inverse'
  );

  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Statistics__Average,
    'Eq.Math_Statistics__Average'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Statistics__Median,
    'Eq.Math_Statistics__Median'
  );
  builder.add(EGenMode.GenSingle, MathAdvanced.Math_Statistics__Mode, 'Eq.Math_Statistics__Mode');
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Statistics__StandardDeviation,
    'Eq.Math_Statistics__StandardDeviation'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Statistics__Variance,
    'Eq.Math_Statistics__Variance'
  );
  builder.add(
    EGenMode.GenSingle,
    MathAdvanced.Math_Statistics__Correlation,
    'Eq.Math_Statistics__Correlation'
  );

  builder.add(
    EGenMode.GenSingle,
    MathFractions.Math_Fractions__Addition__10,
    'Eq.Math_Fractions__Addition__10'
  );
  builder.add(
    EGenMode.GenSingle,
    MathFractions.Math_Fractions__Addition__10_SameDenominator,
    'Eq.Math_Fractions__Addition__10_SameDenominator'
  );
  builder.add(
    EGenMode.GenSingle,
    MathFractions.Math_Fractions__Subtraction__10,
    'Eq.Math_Fractions__Subtraction__10'
  );
  builder.add(
    EGenMode.GenSingle,
    MathFractions.Math_Fractions__Subtraction__10_SameDenominator,
    'Eq.Math_Fractions__Subtraction__10_SameDenominator'
  );
  builder.add(
    EGenMode.GenSingle,
    MathFractions.Math_Fractions__Multiplication__10,
    'Eq.Math_Fractions__Multiplication__10'
  );
  builder.add(
    EGenMode.GenSingle,
    MathFractions.Math_Fractions__Division__10,
    'Eq.Math_Fractions__Division__10'
  );

  builder.add(
    EGenMode.GenSingle,
    MathClocks.Math_Clock_TimeLeft__Base,
    'Eq.Math_Clock_TimeLeft__Base'
  );
  builder.add(
    EGenMode.GenSingle,
    MathClocks.Math_Clock_TimeLeft__Hours,
    'Eq.Math_Clock_TimeLeft__Hours'
  );
  builder.add(
    EGenMode.GenSingle,
    MathClocks.Math_Clock_TimeLeft__Minutes,
    'Eq.Math_Clock_TimeLeft__Minutes'
  );
  builder.add(
    EGenMode.GenSingle,
    MathClocks.Math_Clock_TimeLeft__Minutes5,
    'Eq.Math_Clock_TimeLeft__Minutes5'
  );

  builder.add(
    EGenMode.GenSingle,
    MathNumbersEnglish.Math_Numbers_English__Addition_To100,
    'Eq.Math_Numbers_English__Addition_To100'
  );
}
